var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSplideSlide',{staticClass:"atom-image-thumb-vslider"},[_c('div',{staticClass:"owl atom-image-thumb-slider"},[_c('div',{staticClass:"background-image",style:({
        'background-image': `url(${_vm.resourceUrl(_vm.sliderImage.thumb)})`
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }